import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import { FruitPropsType,centerClassType } from 'src/views/harvesting/fruit-profile/model' ; 
import { useAlertContext } from 'src/context/AlertContext';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';

const classOptions = ['144-1', '145', '146', '147', '148','149','Not Sure'];

interface BlacklistTextFieldType {
  fruit: FruitPropsType;
  checkDate: FruitPropsType| false;
  backFunc: () => void;
  handleClose: () => void;
}
const BlacklistTextField: React.FC<BlacklistTextFieldType> = ({
  fruit,
  checkDate,
  backFunc,
  handleClose,
}) => {
  const [reason, setReason] = useState('');
  const [centerClass, setCenterClass] = useState<centerClassType>('148');
  const {useAlert} = useAlertContext();
  const {setFruitNewBlacklisted} = useHarvestingContext();
  
  const confirmBlacklist = () => {
    if (centerClass&&reason) {
      // blacklistFishes(fruit.id, reason, centerClass);
      setFruitNewBlacklisted(fruit,checkDate,reason,centerClass);
      // handleClose();
    } else {
      useAlert('Reason and center class are required','warning');
    }

   
  };
  return (
    <>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id="demo-simple-select-label">
          Which Center Class *
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={centerClass}
          label="Which Center Class *"
          onChange={(e) => setCenterClass(e.target.value as centerClassType)}
        >
          {classOptions.map((option, idx) => (
            <MenuItem value={option} key={idx}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box pt={2}>
        <TextField
          id="outlined-multiline-static"
          label="Blacklisting Reason *"
          placeholder="What's the reason you would like to blacklist this fish?"
          multiline
          rows={5}
          defaultValue="Default Value"
          variant="outlined"
          fullWidth
          value={reason}
          // autoComplete="blacklist"
          onChange={(e) => setReason(e.target.value)}
          style={{ minWidth: '300px' }}
        />
      </Box>
      <Box pt={2} style={{ display: 'flex' }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={confirmBlacklist}
          style={{ marginLeft: 'auto' }}
        >
          Blacklist please!
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={backFunc}
          style={{ marginLeft: 8 }}
        >
          Back
        </Button>
      </Box>
    </>
  );
};

export default BlacklistTextField;
